import 'react-hot-loader';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import './index.global.css';
import App from './app';
import store from './store';
import * as serviceWorker from './serviceWorker';

const app = () => (
  <Router>
    <Provider store={store}>
      <App />
    </Provider>
  </Router>
);

const preventDrop = (e) => {
  e.preventDefault();
  e.stopPropagation();
};

window.addEventListener('drop', preventDrop);
window.addEventListener('dragend', preventDrop);
window.addEventListener('dragover', preventDrop);

ReactDOM.render(app(), document.getElementById('root'));

window.addEventListener('storage', (event) => {
  if (event.key === 'updatedStore') {
    window.isDirty = true;
  }
});

// Handle unhandled promise rejections from service worker message ports
// This error occurs when the service worker terminates/updates during message passing
// It's harmless and expected during service worker updates
// Set up early to catch errors that happen on page load
window.addEventListener('unhandledrejection', (event) => {
  if (event.reason && typeof event.reason === 'object') {
    const errorMessage = event.reason.message || event.reason.toString() || '';
    if (errorMessage.includes('message port closed')
        || errorMessage.includes('MessagePort closed')) {
      // Suppress this harmless error - it's expected during service worker updates
      event.preventDefault();
    }
  }
  // Let other unhandled rejections propagate normally
});

if (process.env.REACT_APP_ENV === 'production' || process.env.REACT_APP_ENV === 'staging') {
  serviceWorker.register();
} else {
  // Enable service worker in development for testing notification token registration
  // Comment out the line below if you don't want SW in development
  // serviceWorker.register();
}
